import React, { useState } from 'react';
import { BiMenu } from 'react-icons/bi';
import { iconButtonStyles } from '../styles/commonStyles';
import SidebarMenu from './Layout/SidebarMenu';
import { useUserLevel } from '../hooks/useUserLevel';

const AppHeaderLayout = ({ title, description, rightContent, leftContent, children, showBack, onBack, headerContent, sidebarMenuOpen, onSidebarMenuOpen, onSidebarMenuClose, headerClassName }) => {
    const [internalSidebarMenuOpen, setInternalSidebarMenuOpen] = useState(false);
    const { hasFeature } = useUserLevel();
    const menuOpen = typeof sidebarMenuOpen === 'boolean' ? sidebarMenuOpen : internalSidebarMenuOpen;
    const handleOpen = onSidebarMenuOpen || (() => setInternalSidebarMenuOpen(true));
    const handleClose = onSidebarMenuClose || (() => setInternalSidebarMenuOpen(false));

    return (
        <div className="flex flex-col h-full">
            {hasFeature('BASE_CONTENT_HEADER') && (
                <div className={`px-4 py-2 z-30 border-b border-gray-200 dark:border-gray-900 transition-colors flex items-center justify-between min-h-[56px] h-[56px] ${headerClassName ? headerClassName : 'bg-white dark:bg-gray-700'}`}>
                    <div className="flex items-center gap-2">
                        {/* Кастомный левый контент (например, BackButton, ChannelInfo) */}
                        {leftContent && React.isValidElement(leftContent) && typeof leftContent.type !== 'string'
                            ? React.cloneElement(leftContent, { onSidebarMenuOpen: handleOpen })
                            : leftContent}
                        {/* Если не передан leftContent, рендерим стандартный заголовок */}
                        {!leftContent && (
                            <>
                                <button className={iconButtonStyles + " block sm:hidden mr-2"} onClick={handleOpen} aria-label="Открыть меню">
                                    <BiMenu className="text-2xl" />
                                </button>
                                {showBack && (
                                    <button onClick={onBack} className={iconButtonStyles + ' mr-2'} aria-label="Назад">
                                        ←
                                    </button>
                                )}
                                <div>
                                    <h2 className="font-semibold leading-tight">{title}</h2>
                                    {description && <div className="text-xs text-gray-500 dark:text-gray-400">{description}</div>}
                                    {headerContent}
                                </div>
                            </>
                        )}
                    </div>
                    <div className="flex items-center gap-4">
                        {rightContent}
                    </div>
                </div>
            )}
            <div className="flex-1 min-h-0 overflow-y-auto">
                {children}
            </div>
            {/* SidebarMenu для мобильных */}
            <SidebarMenu
                isOpen={menuOpen}
                onClose={handleClose}
                isAuthenticated={true}
                onLoginClick={() => {}}
                onCreateChannelClick={() => {}}
                onOpen={handleOpen}
            />
        </div>
    );
};

export default AppHeaderLayout; 